import React from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export type ConfigureInitializeStateProps = {
  message: string;
  onInitialize?: () => void;
  initializing?: boolean;
  buttonLabel?: string;
  warningMessage?: string | null;
  errorMessage?: string | null;
  loading?: boolean;
  loadingMessage?: string;
  disabled?: boolean;
  actions?: React.ReactNode;
};

export const ConfigureInitializeState = ({
  message,
  onInitialize,
  initializing = false,
  buttonLabel = 'Initialize Settings',
  warningMessage,
  errorMessage,
  loading = false,
  loadingMessage,
  disabled = false,
  actions,
}: ConfigureInitializeStateProps) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5,
          py: 4,
        }}
      >
        <CircularProgress size={28} />
        {loadingMessage ? (
          <Typography color="text.secondary" sx={{ textAlign: 'center', maxWidth: 520 }}>
            {loadingMessage}
          </Typography>
        ) : null}
      </Box>
    );
  }

  return (
    <>
      {warningMessage ? (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {warningMessage}
        </Alert>
      ) : null}
      {errorMessage ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      ) : null}
      {message ? (
        <Alert severity="info" sx={{ mb: 2 }}>
          {message}
        </Alert>
      ) : null}
      {actions ?? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PlayArrowIcon />}
            onClick={onInitialize}
            disabled={disabled || initializing || !onInitialize}
          >
            {initializing ? 'Initializing...' : buttonLabel}
          </Button>
        </Box>
      )}
    </>
  );
};

export default ConfigureInitializeState;
